import React from "react";
import Button from "./Button";

const HangupButton = ({ text, onClick, kioskmode }) => (
  <Button
    className={kioskmode === true ? "hangup-button-kiosk" : "hangup-button"}
    text={text}
    title={text}
    icon="call_end"
    onClick={onClick}
  />
);

export default HangupButton;






// WEBPACK FOOTER //
// ./src/components/buttons/HangupButton.jsx